export const PERMS = {
    READ: 'report_driver_timesheets.read',
    EXPORT: 'report_driver_timesheets.export',
    CREATE: 'report_driver_timesheets.create',
    UPDATE: 'report_driver_timesheets.update',
    DELETE: 'report_driver_timesheets.delete',
}
